<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let updateFilter;
  export let checked;
  export let filter;
  export let filters;

  const onChange = () => updateFilter(filter, { id: 1 });
</script>

<div class="fizz-card side-filter fizz-inset-vertical-8">
  <details class="fizz-accordion" open={true}>
    <summary class="side-filter-header">
      <span class="fizz-heading-6">Inventory</span>
    </summary>
    <div class="fizz-inset-horizontal-16 fizz-flow-8">
      <dl class="fizz-overflow-y side-filter__list">
        <dt class="side-filter__item fizz-stack-8">
          <p>
            <small>Filter products with at least 1 size verified in stock.</small>
          </p>
        </dt>
        <dt class="side-filter__item">
          <label class="fizz-flex-row-8 fizz-stack-4 cursor-pointer" for="in-stock-checkbox">
            <input
              type="checkbox"
              class="fizz-checkbox"
              name="in_stock"
              id="in-stock-checkbox"
              {checked}
              on:change={onChange}
            />

            <span class="fizz-flex-row-4 fizz-text-positive">
              <span class="fizz-inline-4">
                <Icon className="fizz-icon-16" type="CheckCircle" />
              </span>
              <span>In stock</span>
            </span>

            <span class="fizz-text-subdued" style="margin-left: auto">({filters[0].count})</span>
          </label>
        </dt>
      </dl>
    </div>
  </details>
</div>
